<template>
    <div v-if="showing">
      <div>
        <modal-mask></modal-mask>
      </div>

      <div class="pay-panel-bottom" :style="`background: ${h5ConfigDetails[0]['fontColor']['secondaryPopBg'][0]};`">
      <img @click="_close" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['wholeImg']['secondaryPopClose'][0]}`" class="modal-close" alt="">
        <div class="title" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTitleColor'][0]};`">{{h5ConfigDetails[0]['buyPop']['title'][0]}}</div>
        <div class="product-list">
          <div class='product-container' :class='[isInIos && myProductList.length > 4 ? "ios" : "android"]'>
            <div v-for="(item, idx) in myProductList" :key="idx" @click="_choose_product(idx, item)" class="product-item">
              <div v-if="item['label']" class='product-tag' :style="`background: ${h5ConfigDetails[0]['buyPop']['discountBgColor'][0]};color: ${h5ConfigDetails[0]['buyPop']['discountColor'][0]};`">{{item.label}}</div>
              <img :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['wholeImg']['productBg'][0]}`" alt="">
              <img :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['wholeImg']['productChoosed'][0]}`" alt="" v-if="idx === choosedIdx" class="product-choosed">
              <div class="product-name">{{item.description}}</div>
              <div class="product-price">￥<span>{{item.perMonthPrice}}</span>/月</div>
            </div>
          </div>
        </div>
        <img class="buy-button" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['wholeImg']['popBuyBtn'][0]}`" alt="" @click="_to_buy">
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import appBridge from '@/config/appBridge'
// import { global } from '@/config/global'
import ModalMask from '@/components/modal/ModalMask'
import { baseUrl } from '@/config/env'
import { $findProdByFlag } from '@/util/util'

export default {
  name: 'pay-panel-bottom',

  components: {
    ModalMask
  },
  props: [],
  data () {
    return {
      showing: false,
      title: '',
      choosedIdx: 0,
      baseUrl,
      myProductList: [],
      chooseProduct: '', // 选中的产品
      products: []
    }
  },
  mounted () {
    try {
      // console.log(this.h5ConfigDetails)
      this._filter_by_cofig()
      this.chooseProduct = this.myProductList[0]
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    _filter_by_cofig() {
      this.products = this.productList.filter((product) => {
        return product.productName.includes(`_blind`) || Number(product.appClientParas.isBlindBox) === 1
        // return Number(product.appClientParas.isBlindBox) === 1 华为渠道调用app接口取不到客户端参数
      })
      const flagConfigs = this.h5ConfigDetails[0]['buyPop'][`${this.isInIos ? 'ios' : 'android'}-flag`]
      // console.log(flagConfigs)
      flagConfigs.forEach((ele) => {
        const prod = $findProdByFlag(this.products, ele)
        if (!prod) {
          return
        }
        this.myProductList.push(prod)
      })
    },
    _to_buy () {
      this.$sensors.track('app_page_click', {button_name: 'suspension_pay'})
      this.$sensors.track('app_popup_click', {button_name: this.chooseProduct.description})
      // console.log(this.chooseProduct)
      appBridge.startPay(this.chooseProduct, this.userInfo)
      window.eventBus.$emit('payInH5', this.chooseProduct, true)
    },
    // 选中的索引值和产品
    _choose_product (idx, item) {
      this.choosedIdx = idx
      this.chooseProduct = item
    },
    _close () {
      this.showing = false
    },
    show () {
      this.showing = true
    },
  },
  computed: {
    ...mapState(['productList', 'h5ConfigImgPath', 'h5ConfigDetails', 'userInfo', 'isInIos'])
  },
  watch: {
  }
}
</script>

<style scoped lang="less">
  @import '../../style/mixin';

  .pay-panel-bottom {
    width: 100%;
    height: 27.9rem;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: @modal-border-radius;
    z-index: 1000;
  }
  .title {
    font-size: 1.9rem;
    font-weight: bold;
    text-align: center;
    margin: 2rem auto 2.3rem;
  }
  .close {
    width: 1.9rem;
    height: 1.9rem;
    position: absolute;
    top: 1.1rem;
    right: 1.1rem;
  }
  .buy-button {
    height: 4.3rem;
    margin: 0 auto;
    display: block;
  }
  .product-list {
    width: 100%;
    height: 11.4rem;
    font-size: 1.5rem;
    padding: 0 1.1rem;
    margin-bottom: 2.3rem;
    overflow-x: auto;
  }
  .product-price {
    font-size: 3rem;
  }
  .product-price span {
    font-weight: bold;
  }
  .product-choosed {
    width: 100%;
  }
  .product-container{
    display: flex;
    width: auto;
    text-align: center;
  }
  .product-container.ios{
    width: auto;
    height: 100%;
  }
  .product-container.android{
    width: auto;
    height: 100%;
  }
  .product-item {
    flex-basis: 23%;
    flex-shrink: 0;
    height: 11.3rem;
    position: relative;
    display: inline-block;
  }
  .product-container.ios .product-item:not(:last-child){
    margin-right: 0.5rem;
  }
  .product-container.android .product-item:not(:last-child){
    margin-right: 0.8rem;
  }
  .product-tag{
    position: absolute;
    left: 0;
    top: 0;
    height: 1.7rem;
    line-height: 1.7rem;
    padding: 0 0.5rem;
    font-size: 1rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-family: PingFangSC-Regular, PingFang SC;
    text-align: center;
    overflow: hidden;
    border-radius: .7rem 0 .7rem 0;
    z-index: 3;
  }
  .product-name, .product-price {
    text-align: center;
    position: inherit;
  }
  .product-name {
    margin-top: 3rem;
    font-size: 1.3rem;
    font-weight: bold;
    font-family: PingFangSC-Semibold, PingFang SC;
    // .single-line;
  }
  .product-price {
    margin-top: 1.2rem;
    font-size: 1.2rem;
  }
  .product-price span {
    font-size: 2.7rem;
    font-weight: bold;
    font-family: DINAlternate-Bold, DINAlternate
  }
  .product-item img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
</style>
